import React from "react";
import { ErrorBoundary } from "tsi-common-react/src/components/ErrorBoundary/index";

// Client-only loader for the configure-gifts-with-purchase app. The app lives
// inside the React document (rendered by ConfigureGiftsDocumentTemplate) rather
// than mounted via a separate createRoot/dynamicPlaceComponent, but its
// dependency tree is not SSR-safe, so it is lazy-imported and gated to
// client-only paint: the server and the first hydration render both produce
// null (no mismatch), and the real app mounts after hydration and loads its
// data client-side.
const ConfigureGiftsAppInner = React.lazy(
    () => import("./ConfigureGiftsAppInner"),
);

// The ErrorBoundary wraps Suspense (not just the inner app) so it catches both
// a lazy chunk-load failure -- which throws at the Suspense site -- and any
// render error from the app. The app renders inside the document's single React
// root, so an uncaught failure here would otherwise blank the whole document;
// the boundary keeps the blast radius scoped to
// #configure-gifts-with-purchase-app.
export const ConfigureGiftsApp = (): React.ReactNode => {
    const [isHydrated, setIsHydrated] = React.useState(false);
    React.useEffect(() => setIsHydrated(true), []);
    if (!isHydrated) {
        return null;
    }
    return (
        <ErrorBoundary>
            <React.Suspense fallback={null}>
                <ConfigureGiftsAppInner />
            </React.Suspense>
        </ErrorBoundary>
    );
};
